/**
 * Combine all sagas in this file and export the rootSaga.
 */

import {all} from 'redux-saga/effects';
import orderSaga from '../pages/orders/saga';
import bundleSaga from '../pages/bundles/saga';
import uploadInfoSaga from '../pages/uploadInfo/saga';
import loginSaga from '../pages/login/saga';
import userSaga from '../pages/users/saga';
import partnersSaga from '../pages/partners/saga';
import centerSaga from '../pages/centers/saga';
import productSaga from '../pages/products/saga';
import warehouseSaga from '../pages/warehouses/saga';
import reportsSaga from '../pages/reports/saga';
import parcelsSaga from '../pages/parcels/saga';
// import warehouseZonesSaga from '../pages/warehouseZones/saga';
// import warehouseZoneAisleSaga from '../pages/warehouseZone-aisles/saga';
// import warehouseZoneColumnSaga from '../pages/warehouseZone-column/saga';
// import warehouseZoneRowSaga from '../pages/warehouseZone-row/saga';
// import warehouseZoneUnitSaga from '../pages/warehouseZone-unit/saga';
import providerSaga from '../pages/providers/saga';
import sellerSaga from '../pages/sellers/saga';
import invoicesSaga from '../pages/bill/saga/saga';
// import fleetsSaga from '../pages/fleets/saga';
// import webHooksSaga from '../pages/webhooks/saga';

export default function* rootSaga() {
  yield all([
    loginSaga(),
    orderSaga(),
    bundleSaga(),
    uploadInfoSaga(),
    userSaga(),
    centerSaga(),
    partnersSaga(),
    productSaga(),
    warehouseSaga(),
    reportsSaga(),
    parcelsSaga(),
    // warehouseZonesSaga(),
    // warehouseZoneAisleSaga(),
    // warehouseZoneColumnSaga(),
    // warehouseZoneRowSaga(),
    // warehouseZoneUnitSaga(),
    providerSaga(),
    sellerSaga(),
    invoicesSaga(),
    // webHooksSaga(),
  ]);
}
